export default __webpack_public_path__ + "static/dog-ea3e5610a82324a5aff31bda3cf0a294.mp4";